import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'mobx-react';

import './index.scss';
import App from './App';
import RootStore from './stores/RootStore';
import reportWebVitals from './reportWebVitals';

// eslint-disable-next-line max-len, no-prototype-builtins, @typescript-eslint/no-explicit-any
if (!new class { x: any; }().hasOwnProperty('x')) throw new Error('Transpiler is not configured correctly');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

const rootStore = new RootStore();

root.render(
  <React.StrictMode>
    <Provider rootStore={rootStore}>
      <App />
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
